import { ROLE_SUPERADMIN } from '../../constants/roles';
import { createHasDashboardAccessSelector, } from '../session';

export const selectCanAccessDashoard = createHasDashboardAccessSelector([ROLE_SUPERADMIN]);